import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { eur } from "../../utils/format";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("el-GR", { weekday: "long", day: "2-digit", month: "2-digit" });
};

const List = () => {
  const navigate = useNavigate();
  const reports = useSelector((state) => state.dailyReports.list);

  return (
    <div className="space-y-3">
      {reports.map((report) => (
        <button
          key={report.date}
          onClick={() => navigate(`/daily-reports/${report.date}`)}
          className="block w-full overflow-hidden rounded-2xl border border-brand-600/10 bg-white text-left
                     shadow-card transition active:scale-[0.99]"
        >
          <div className="bg-brand-600 px-4 py-2.5">
            <h3 className="font-semibold capitalize text-white">{formatDate(report.date)}</h3>
          </div>
          <div className="flex items-center justify-between px-4 py-3 text-sm">
            <span className="flex items-center gap-1.5 font-medium text-emerald-600">
              <FaArrowUp size={12} /> {eur(report.totalIncomes)}
            </span>
            <span className="flex items-center gap-1.5 font-medium text-rose-500">
              <FaArrowDown size={12} /> {eur(report.totalExpenses)}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
};

export default List;
